import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

export class PaymentTypeChangeAction extends BaseAction<void, string> {
    override async run(): Promise<void | null> {
        try {
            const paymentState = this.params;
            if (paymentState) {
                updateRecoilState("paymentStateAtom", paymentState);
            }
        } catch (error) {
            console.error("Error during payment type change:", error);
        }
    }
}

export const paymentTypeChangeAction = new PaymentTypeChangeAction();
